import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api";

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const apiLogin = (email, password) =>
  axios.post(`${BASE}/auth/login`, { email, password });

export const apiLogout = (token) =>
  axios.delete(`${BASE}/auth/logout`, { headers: authHeader(token) });

export const getCourses = (token, userId) =>
  axios.get(`${BASE}/courses`, {
    params: { user_id: userId },
    headers: authHeader(token),
  });

export const getCourseDetail = (token, courseIdentifier) =>
  axios.get(`${BASE}/courses/${encodeURIComponent(courseIdentifier)}/detail`, {
    headers: authHeader(token),
  });

export const getLesson = (token, courseIdentifier, lessonId) =>
  axios.get(`${BASE}/courses/${encodeURIComponent(courseIdentifier)}/lesson/${lessonId}`, {
    headers: authHeader(token),
  });

export const getProgress = (token, userId) =>
  axios.get(`${BASE}/progress`, {
    params: { user_id: userId },
    headers: authHeader(token),
  });

export const updateLessonProgress = (token, data) =>
  axios.post(`${BASE}/progress/lesson`, data, { headers: authHeader(token) });

export const getExam = (token, courseIdentifier) =>
  axios.get(`${BASE}/courses/${encodeURIComponent(courseIdentifier)}/exam`, {
    headers: authHeader(token),
  });

export const submitExam = (token, courseIdentifier, data) =>
  axios.post(`${BASE}/courses/${encodeURIComponent(courseIdentifier)}/exam/submit`, data, {
    headers: authHeader(token),
  });

export const downloadCertificate = async (token, assignmentId) => {
  const resp = await axios.get(`${BASE}/certificates/${assignmentId}`, {
    headers: authHeader(token),
    responseType: "blob",
    validateStatus: (status) => status < 500, // Don't throw on 4xx errors
  });
  
  // Check if response is an error
  if (resp.status !== 200) {
    // Convert blob error to JSON
    const text = await resp.data.text();
    let errorData;
    try {
      errorData = JSON.parse(text);
    } catch {
      errorData = { detail: "Ismeretlen hiba történt" };
    }
    throw new Error(errorData.detail || "Bizonyítvány letöltése sikertelen");
  }
  
  return resp;
};
